/**
 * Created by Balazs Foldesi on 2018. 01. 11.
 */

let endPoints = {};

export default class EndPointProtection {

	constructor(localStorageService) {
		'ngInject';
		this.localStorageService = localStorageService;
	}



	registerEndpointParams(endPoint, interval, amount) {
		endPoints[endPoint] = {
			calls: this.localStorageService.get(endPoint) || [],
			interval: interval,
			amount: amount
		};
	}

	registerEndpointUsage(endPoint) {
		endPoints[endPoint].calls.push(Date.now());
		this.localStorageService.set(endPoint, endPoints[endPoint].calls);
	}

	isEndPointOpenForMoreRequest(endPoint) {

		let usageStats = endPoints[endPoint];
		let callsMapInSecs;
		let timeWindowStart;
		let callsNumInTimewindow;
		let nowDateInSecs = Date.now() / 1000;
		let calls = this.localStorageService
			.get(endPoint);

		if (calls) {
			callsMapInSecs = calls.map(x => x / 1000);
		}

		if(usageStats) {
			timeWindowStart = nowDateInSecs - usageStats.interval;
		}

		if(callsMapInSecs) {
			callsNumInTimewindow = callsMapInSecs.filter(call => call > timeWindowStart);
			this.localStorageService.set(endPoint, callsNumInTimewindow);
		}

		if(endPoints[endPoint]) {
			// Inicializáláskor +1-et logol a calls
			if (callsNumInTimewindow && callsNumInTimewindow.length < endPoints[endPoint].amount + 1) {
				return true;
			} else {
				return false;
			}
		}

		return true;

	}
}
